module.exports = __webpack_public_path__ + "static/media/CiCi-Desktop-Default 2.7669472a.svg";